import axios from 'axios'
import Router from '../routes'
import localforage from 'localforage'
import Configuration from '@/configuration';

export default () => {
  axios.interceptors.request.use(request => {
    request.headers.common['Content-Type'] = 'application/json'

    return localforage
      .getItem('authtoken')
      .then(token => {
        request.headers.common['Authorization'] = token
        request.headers.common['X-AUTH-TOKEN'] = Configuration.value('tenant')
        return request
      })
      .catch(() => {
        return request
      })
  })

  axios.interceptors.response.use(undefined, err => {
    return new Promise(() => {
      if (err.response.status === 403 || err.response.status === 401) {
        if(Router.currentRoute.name !== 'PasswordReset') {
          Router.push({ path: '/login', query: {redirect: Router.currentRoute.query} }).catch(()=>{})
        }
      }
      throw err
    })
  })

  return axios
}
